import * as React from 'react';
import Checkbox from '@mui/material/Checkbox';
import ListItemText from '@mui/material/ListItemText';
import MenuItem from '@mui/material/MenuItem';
import IconButton from '@mui/material/IconButton';
import SettingsIcon from '@mui/icons-material/MoreHoriz';
import Popover from '@mui/material/Popover';
import { isNewUi } from '../../redesign/uiMode';

export class UserRolesResources extends React.Component {
	constructor() {
		super();

		this.state = {
			userRolesList: []
		};

		this.popover_handleClickOpen = this.popover_handleClickOpen.bind(this);
		this.popover_handleClose = this.popover_handleClose.bind(this);
		this.userRoles_changeHandler = this.userRoles_changeHandler.bind(this);
	}

	componentDidMount() {
		var userRolesList = this.props.info.userRolesList;

		userRolesList.map((userRolesResource, index) => (
			userRolesResource.checked = this.props.info.apadUserRolesResource.findIndex(urr => urr.userRoleId === userRolesResource.userRoleId) > -1));

		this.setState({ userRolesList: userRolesList });
	}

	userRoles_changeHandler(event) {
		var userRolesList = this.state.userRolesList;
		userRolesList.find(ur => ur.userRoleId === parseInt(event.target.value)).checked = event.target.checked;

		this.setState({ userRolesList: userRolesList });
	}

	popover_handleClickOpen(event) {
		this.setState({ anchorEl: event.currentTarget });
	}

	popover_handleClose(event) {
		this.setState({ anchorEl: null });

		if (this.props.onClose != null) {
			this.props.onClose(this.state.userRolesList.filter(ur => ur.checked));
		}
	}

	render() {
		var that = this;
		// New UI (R17): a labelled button, a titled list that opens under it, and Done. Closing still applies the ticks,
		// as in Classic.
		const newUi = isNewUi();

		return (
			<div>
				{newUi
					? <button type="button" className="apw2-btn sm apw2-pick-groups" aria-haspopup="dialog" onClick={this.popover_handleClickOpen}>Choose groups</button>
					: <IconButton value="color" aria-label="Field Source" className="textAlignmentIcon" onClick={this.popover_handleClickOpen}>
					<SettingsIcon />
				</IconButton>}
				<Popover
					open={this.state.anchorEl != null}
					anchorEl={this.state.anchorEl}
					onClose={this.popover_handleClose}
					anchorOrigin={{
						vertical: 'bottom',
						horizontal: newUi ? 'left' : 'right',
					}}
					transformOrigin={{
						vertical: 'top',
						horizontal: newUi ? 'left' : 'right',
					}}
					{...(newUi ? { PaperProps: { className: 'apw2-groups-pop', role: 'dialog', 'aria-label': 'User groups' } } : {})}>
					{newUi ? <div className="apw2-groups-pop-h">User groups</div> : null}
					{
						this.state.userRolesList.map((userRolesResource, index) => (
							<MenuItem key={index}>
								<Checkbox key={index+1} color="default" checked={userRolesResource.checked} value={userRolesResource.userRoleId} onChange={that.userRoles_changeHandler} />
								<ListItemText key={index+2} primary={userRolesResource.userRoleName} />
							</MenuItem>
						))
					}
					{newUi ? <div className="apw2-groups-pop-f"><button type="button" className="apw2-btn primary sm" onClick={this.popover_handleClose}>Done</button></div> : null}
				</Popover>
			</div>
		);
	}
}
